import { StaticBaseDao } from '@/dao';
import { EventLiveLogos } from '@/objects/generated';

export class EventLiveLogosDao extends StaticBaseDao {
    public static async GetEventLiveLogos(EventID: number): Promise<EventLiveLogos | null> {
        return this.BaseFetch(EventLiveLogos, `EventLiveLogos/` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), 'GET');
    }
    public static async SaveEventLiveLogos(eventLiveLogos: EventLiveLogos, EventID: number): Promise<boolean | null> {
        return this.Post(`EventLiveLogos/` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`), eventLiveLogos);
    }
}
